// In case of changing values, they must be changed in _config.scss, FullPageBanner-test.js, Ad-test.js, HeroBanner-test.js as well.
export const desktopBreakpoint = 1024;
export const tabletBreakpoint = 321;
export const mobileBreakpoint = 1;
import type { PageType, BannerType } from "../utils/BannerContainer";
export type ResponseType = Banner | "FAIL";
export type Alignment = "left" | "center" | "right";
export type subimage = {
	imageUrl: string;
	width: number;
	height: number;
};
export type TimeSlot = {
	from_timestamp?: number;
	until_timestampy?: number;
};
export type ConfiguredTargetParams = {
	customerTargetGroups?: Array<string>;
	customerCategoryGroups?: Array<string>;
	orderType?: string;
	customerTypes?: Array<string>;
	stores?: Array<string>;
	time_slots?: Array<TimeSlot>;
	capping?: {
		session?: number;
	};
};
export type Article = {
	articleNumber: string;
	bettyBundleId: string;
	bettyVariantId: string;
	bundleNumber: string;
	variantNumber: string;
};
export type ArticlesTeaser = {
	articleId: Article;
	text?: string;
	link: {
		text: string;
		url: string;
	};
};
export type Banner = {
	imageUrl: string;
	width: number;
	height: number;
	tablet?: subimage;
	mobile?: subimage;
	link?: string;
	linkType?: string;
	text: string;
	type: BannerType;
	page: PageType;
	isI18n?: boolean;
	textAlignment: Alignment;
	placementId?: string;
	placementName?: string;
	campaignId?: string;
	campaignName?: string;
	creativeId?: string;
	advertisement?: boolean;
	articleData?: Array<Record<string, any>>;
	articleSponsoredDesc?: Array<ArticlesTeaser>;
	orderType?: string;
	configuredTargetParams?: ConfiguredTargetParams;
};
export function getScreenType(): string {
	if (window.innerWidth >= desktopBreakpoint) {
		return "desktop";
	} else if (window.innerWidth >= tabletBreakpoint) {
		return "tablet";
	} else if (window.innerWidth < tabletBreakpoint) {
		return "mobile";
	}

	return "unknown";
}
